export class User {

    manager_id: number = 0
    department_id: number = 0
    privilege_group_id: number = 0
    name: string = ""
    username: string = ""
    phone: string = ""
    email: string = ""
    address: string = ""
    avatar: string = ""
    gender: number = 1
    joining_date: string = ""
    birthday: string = ""
    id_card_number: string = ""
    // salary_level_id: number = 0

    constructor(data?: Partial<User>) {
        Object.assign(this, data);
    }
}